export const SkeletonBlock = ({ className = "" }) => (
  <div
    aria-hidden="true"
    className={`animate-pulse rounded-md bg-slate-200/80 ${className}`}
  />
);

export const PublicPortalHeaderSkeleton = () => (
  <header className="w-full border-b border-cfCardBorder bg-cfSecondary">
    <div className="flex w-full items-center justify-between px-5 py-3 sm:px-8 lg:px-12">
      <div className="flex items-center gap-3">
        <SkeletonBlock className="h-12 w-12 rounded-lg" />
        <div className="space-y-2">
          <SkeletonBlock className="h-5 w-36" />
          <SkeletonBlock className="h-3 w-24" />
        </div>
      </div>
      <SkeletonBlock className="hidden h-9 w-24 rounded-[8px] sm:block" />
    </div>
  </header>
);

export const PublicPortalHeroBannerSkeleton = () => (
  <>
    <SkeletonBlock className="mx-auto h-[240px] w-full max-w-md rounded-2xl lg:hidden" />
    <SkeletonBlock className="hidden aspect-[2240/1260] h-auto w-full rounded-none lg:block" />
  </>
);

export const PublicPortalVerificationMethodsSkeleton = () => (
  <section className="w-full px-5 pb-14 pt-4 sm:px-8 sm:pt-6 lg:px-12 lg:pt-8">
    <SkeletonBlock className="mx-auto mb-7 h-8 w-64" />
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          className="flex min-h-[280px] w-full min-w-0 flex-col items-center overflow-hidden rounded-2xl border border-cfCardBorder bg-cfSecondary p-5 sm:p-7"
          key={index}
        >
          <SkeletonBlock className="mb-5 h-14 w-14 rounded-full" />
          <SkeletonBlock className="mb-3 h-6 w-40" />
          <SkeletonBlock className="mb-2 h-4 w-full" />
          <SkeletonBlock className="mb-6 h-4 w-5/6" />
          <SkeletonBlock className="h-11 w-44 rounded-[8px]" />
        </div>
      ))}
    </div>
  </section>
);

export const PublicPortalFooterSkeleton = () => (
  <footer className="w-full bg-publicPortal-footer">
    <div className="grid w-full gap-9 px-5 py-12 sm:px-8 md:grid-cols-2 lg:grid-cols-4 lg:px-12">
      {Array.from({ length: 4 }).map((_, index) => (
        <div className="space-y-4" key={index}>
          <SkeletonBlock className="h-12 w-40" />
          <SkeletonBlock className="h-16 w-full" />
          <SkeletonBlock className="h-4 w-full" />
          <SkeletonBlock className="h-4 w-4/5" />
        </div>
      ))}
    </div>
    <div className="border-t border-white/10 px-5 py-6">
      <SkeletonBlock className="mx-auto h-4 w-64" />
    </div>
  </footer>
);

export const PublicPortalDocumentPreviewSkeleton = () => (
  <SkeletonBlock className="h-full min-h-[320px] w-full rounded-lg" />
);

export const PublicPortalResultDetailsSkeleton = () => (
  <div className="space-y-4">
    <div className="rounded-xl border border-cfCardBorder p-4">
      <SkeletonBlock className="mb-4 h-8 w-56" />
      <SkeletonBlock className="h-4 w-full" />
      <SkeletonBlock className="mt-2 h-4 w-2/3" />
    </div>
    <div className="grid w-full gap-3 md:grid-cols-2 md:items-stretch">
      <div className="rounded-xl border border-cfCardBorder p-4">
        <SkeletonBlock className="mb-4 h-6 w-40" />
        <div className="space-y-3">
          {Array.from({ length: 6 }).map((_, index) => (
            <div className="flex justify-between gap-4" key={index}>
              <SkeletonBlock className="h-4 w-1/3" />
              <SkeletonBlock className="h-4 w-1/2" />
            </div>
          ))}
        </div>
      </div>
      <div className="rounded-xl border border-cfCardBorder p-4">
        <SkeletonBlock className="mb-4 h-6 w-40" />
        <PublicPortalDocumentPreviewSkeleton />
      </div>
    </div>
  </div>
);
